import * as React from "react";
import type { SVGProps } from "react";
const SvgExecutiveCommunications = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={66}
    height={64}
    fill="none"
    {...props}
  >
    <path
      fill="#D3ECF8"
      d="M10.63 50.679a5.3 5.3 0 1 0 0-10.599 5.3 5.3 0 0 0 0 10.599Z"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M10.63 40.95a4.429 4.429 0 1 0 0 8.858 4.429 4.429 0 0 0 0-8.857Zm-6.17 4.43a6.17 6.17 0 1 1 12.339 0 6.17 6.17 0 0 1-12.34 0Z"
      clipRule="evenodd"
    />
    <path
      fill="#D3ECF8"
      d="M18.27 63.124H3.067c-.79 0-1.5-.537-1.59-1.32-.688-6.184 5.826-7.847 9.4-7.879 7.693.453 9.182 4.89 8.924 7.92-.068.769-.763 1.284-1.536 1.284l.005-.005Z"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M10.869 53.055c.02 0 .039 0 .059.002 4.01.235 6.56 1.523 8.058 3.3 1.489 1.767 1.825 3.883 1.683 5.562v.004C20.551 63.234 19.387 64 18.264 64a.867.867 0 0 1-.096-.005H3.067c-1.153 0-2.306-.795-2.454-2.093V61.9c-.191-1.71.114-3.157.779-4.354.66-1.19 1.646-2.08 2.739-2.735 2.165-1.298 4.855-1.74 6.738-1.756Zm7.468 9.201c.377-.028.578-.275.597-.486.115-1.352-.165-2.968-1.279-4.29-1.102-1.308-3.135-2.462-6.8-2.684-1.689.02-4.026.427-5.829 1.508-.896.538-1.633 1.224-2.112 2.087-.474.854-.725 1.933-.571 3.315.031.27.3.548.724.548H18.27c.023 0 .045 0 .067.002Z"
      clipRule="evenodd"
    />
    <path
      fill="#D3ECF8"
      d="M33.005 50.679a5.3 5.3 0 1 0 0-10.599 5.3 5.3 0 0 0 0 10.599Z"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M33.005 40.95a4.429 4.429 0 1 0 0 8.858 4.429 4.429 0 0 0 0-8.857Zm-6.17 4.43a6.17 6.17 0 1 1 12.34 0 6.17 6.17 0 0 1-12.34 0Z"
      clipRule="evenodd"
    />
    <path
      fill="#D3ECF8"
      d="M40.645 63.124H25.444c-.79 0-1.5-.537-1.59-1.32-.689-6.184 5.826-7.847 9.399-7.879 7.694.453 9.183 4.89 8.925 7.92-.069.769-.763 1.284-1.537 1.284l.005-.005Z"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M33.244 53.055c.02 0 .04 0 .059.002 4.01.235 6.56 1.523 8.059 3.3 1.488 1.767 1.825 3.883 1.682 5.562v.004C42.927 63.234 41.764 64 40.64 64a.867.867 0 0 1-.096-.005H25.444c-1.154 0-2.307-.795-2.455-2.093V61.9c-.19-1.71.114-3.157.78-4.354.66-1.19 1.646-2.08 2.738-2.735 2.166-1.298 4.856-1.74 6.738-1.756Zm7.469 9.201c.376-.028.577-.275.597-.486.114-1.352-.165-2.968-1.28-4.29-1.102-1.308-3.135-2.462-6.8-2.684-1.688.02-4.025.427-5.828 1.508-.896.538-1.634 1.224-2.112 2.087-.475.854-.726 1.933-.572 3.315.032.27.3.548.724.548h15.203c.023 0 .045 0 .068.002Z"
      clipRule="evenodd"
    />
    <path
      fill="#D3ECF8"
      d="M33.005 11.469a5.3 5.3 0 1 0 0-10.598 5.3 5.3 0 0 0 0 10.598Z"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M33.005 1.741a4.429 4.429 0 1 0 0 8.857 4.429 4.429 0 0 0 0-8.857Zm-6.17 4.429a6.17 6.17 0 1 1 12.34 0 6.17 6.17 0 0 1-12.34 0Z"
      clipRule="evenodd"
    />
    <path
      fill="#D3ECF8"
      d="M40.645 23.915H25.444c-.79 0-1.5-.537-1.59-1.321-.689-6.184 5.826-7.847 9.399-7.878 7.694.453 9.183 4.889 8.925 7.92-.069.768-.763 1.284-1.537 1.284l.005-.006Z"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M33.244 13.845c.02 0 .04 0 .059.002 4.01.236 6.56 1.523 8.059 3.3 1.488 1.767 1.825 3.884 1.682 5.563v.003c-.117 1.311-1.28 2.077-2.404 2.077a.87.87 0 0 1-.096-.005H25.443c-1.154 0-2.307-.795-2.455-2.093v-.002c-.19-1.71.114-3.156.78-4.354.66-1.19 1.646-2.08 2.738-2.735 2.166-1.298 4.856-1.739 6.738-1.756Zm7.469 9.202c.376-.029.577-.276.597-.487.114-1.352-.165-2.968-1.28-4.29-1.102-1.308-3.135-2.462-6.8-2.683-1.688.019-4.025.427-5.828 1.508-.896.537-1.634 1.224-2.112 2.086-.475.854-.726 1.933-.572 3.315.032.27.3.548.724.548h15.203c.023 0 .045 0 .068.003Z"
      clipRule="evenodd"
    />
    <path
      fill="#D3ECF8"
      d="M55.38 50.679a5.3 5.3 0 1 0 0-10.599 5.3 5.3 0 0 0 0 10.599Z"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M55.38 40.95a4.429 4.429 0 1 0 0 8.858 4.429 4.429 0 0 0 0-8.857Zm-6.17 4.43a6.17 6.17 0 1 1 12.34 0 6.17 6.17 0 0 1-12.34 0Z"
      clipRule="evenodd"
    />
    <path
      fill="#D3ECF8"
      d="M63.016 63.124H47.813c-.79 0-1.5-.537-1.59-1.32-.689-6.184 5.826-7.847 9.4-7.879 7.693.453 9.182 4.89 8.924 7.92-.068.769-.763 1.284-1.537 1.284l.006-.005Z"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M55.614 53.055c.02 0 .04 0 .06.002 4.009.235 6.56 1.523 8.058 3.3 1.489 1.767 1.825 3.883 1.682 5.562v.004C65.297 63.234 64.134 64 63.01 64a.867.867 0 0 1-.095-.005H47.813c-1.154 0-2.306-.795-2.455-2.093V61.9c-.19-1.71.115-3.157.78-4.354.66-1.19 1.646-2.08 2.739-2.735 2.165-1.298 4.855-1.74 6.737-1.756Zm7.469 9.201c.376-.028.577-.275.597-.486.114-1.352-.165-2.968-1.28-4.29-1.102-1.308-3.134-2.462-6.8-2.684-1.688.02-4.025.427-5.828 1.508-.896.538-1.633 1.224-2.112 2.087-.474.854-.725 1.933-.572 3.315.032.27.3.548.725.548h15.203c.022 0 .044 0 .067.002ZM33.005 26.301c.48 0 .87.39.87.87v9.6a.87.87 0 0 1-1.74 0v-9.6c0-.48.389-.87.87-.87ZM9.901 23.857c0-.481.39-.871.87-.871h9.463a.87.87 0 1 1 0 1.741h-8.592v11.864a.87.87 0 0 1-1.74 0V23.856ZM44.8 23.857c0-.481.39-.871.871-.871h9.746c.481 0 .87.39.87.87v12.735a.87.87 0 0 1-1.74 0V24.727H45.67a.87.87 0 0 1-.87-.87Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgExecutiveCommunications;
